export enum SexType {
    Unspecified = "U",
    Male = "M",
    Female = "F",
}